<template>
  <div class="partner">
    <el-button type="primary" size="small" icon="el-icon-plus" @click="handleClick">添加</el-button>

    <el-input v-model="key" size="small" style="margin-left: 20px; width: 200px;" placeholder="搜索"></el-input>

    <el-table :data="list" class="table">
      <el-table-column prop="title" label="名称" width="180"></el-table-column>
      <el-table-column label="logo" width="180">
        <template slot-scope="scope">
          <img class="thumb" :src="scope.row.logo">
        </template>
      </el-table-column>
      <el-table-column label="封面" width="180">
        <template slot-scope="scope">
          <img class="thumb" :src="scope.row.thumb">
        </template>
      </el-table-column>
      <el-table-column label="显示/隐藏" width="180">
        <template slot-scope="scope">
          <el-switch
            :active-value="0"
            :inactive-value="1"
            v-model="scope.row.is_hidden"
            @change="hiddenchange($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="开启机构VIP" width="180">
        <template slot-scope="scope">
          <el-switch
            :active-value="1"
            :inactive-value="0"
            v-model="scope.row.is_need_partner_vip"
            @change="handleStatusChange($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showAppPath(scope.row)">路径</el-button>
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="per_page"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <el-dialog :title="edit?'编辑':'添加'" :visible.sync="dialogVisible" width="900px">
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-form-item label="封面" prop="thumb">
          <img v-if="form.thumb" class="thumb cursor-pointer" :src="form.thumb" title="点击更换" @click="selectThumb">
          <div v-else class="addimg" @click="selectThumb">+</div>
        </el-form-item>
        <el-form-item label="logo" prop="logo">
          <div class="images">
            <img v-if="form.logo" class="thumb cursor-pointer" :src="form.logo" title="点击更换" @click="selectThumb2">
            <div v-else class="addimg" @click="selectThumb2">+</div>
          </div>
        </el-form-item>
        <el-form-item label="轮播图" prop="thumb">
          <div class="images-c">
            <img v-if="form.images && (form.images.length > 0)" v-for="item in form.images" :key="item" class="thumb cursor-pointer" :src="item" title="点击更换" @click="selectImages" />
            <!-- <img v-if="form.images" class="thumb cursor-pointer" :src="form.images" title="点击更换" @click="selectThumb"> -->
            <div class="addimg" @click="selectImages">+</div>
          </div>
        </el-form-item>
        <el-form-item label="名称" prop="title">
          <el-input v-model="form.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item label="名称(英文)" prop="title">
          <el-input v-model="form.title_en" placeholder="标题(英文)"></el-input>
        </el-form-item>
        <el-form-item label="客服微信号" prop="title">
          <el-input v-model="form.wx_name" placeholder="客服微信号"></el-input>
        </el-form-item>
        <el-form-item label="客服二维码" prop="thumb">
          <img v-if="form.wx_qrcode" class="thumb cursor-pointer" :src="form.wx_qrcode" title="点击更换" @click="selectWxQrcode">
          <div v-else class="addimg" @click="selectWxQrcode">+</div>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" type="textarea" placeholder="描述" :autosize="{ minRows: 3}"></el-input>
        </el-form-item>
        <el-form-item label="描述(英文)" prop="description">
          <el-input v-model="form.description_en" type="textarea" placeholder="描述(英文)" :autosize="{ minRows: 3}"></el-input>
        </el-form-item>
        <el-form-item label="展映">
          <el-radio-group v-model="form.is_show_screening_program">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
          <div>
            <el-input v-model="form.screening_programs_title" placeholder="标题（默认为“展映”）" style="width:300px;margin:4px 0;"></el-input>
          </div>
          <div>
            <el-input v-model="form.screening_programs_title_en" placeholder="标题(英文)" style="width:300px;margin:4px 0;"></el-input>
          </div>
          <el-select v-model="form.screening_programs" multiple filterable placeholder="请选择放映项目" style="width:350px;">
            <el-option
              v-for="item in screening"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="影片">
          <el-radio-group v-model="form.is_show_movie">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
          <div>
            <el-input v-model="form.movie_title" placeholder="标题（默认为“影片”）" style="width:300px;margin:4px 0;"></el-input>
          </div>
          <div>
            <el-input v-model="form.movie_title_en" placeholder="标题（英文）" style="width:300px;margin:4px 0;"></el-input>
          </div>
          <el-select v-model="form.movie" multiple filterable placeholder="请选择作品列表" style="width:350px;">
            <el-option
              v-for="item in movie"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专访">
          <el-radio-group v-model="form.is_show_interview">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
          <div>
            <el-input v-model="form.interview_title" placeholder="标题（默认为“专访”）" style="width:300px;margin:4px 0;"></el-input>
          </div>
          <div>
            <el-input v-model="form.interview_title_en" placeholder="标题（英文）" style="width:300px;margin:4px 0;"></el-input>
          </div>
          <el-select v-model="form.interviews" multiple filterable placeholder="请选择导筒专访" style="width:350px;">
            <el-option
              v-for="item in talk"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="!edit" type="primary" @click="submit">确 定</el-button>
        <el-button v-show="edit" type="primary" @click="saveChange">保存更改</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" title="路径" center width="800px">
      <el-form label-width="80px">
        <el-form-item label="小程序">
          <el-input :value="miniAppPath">
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import request from '@/utils/request'
import UploadImg from '@/components/UploadImg'
export default {
  name: 'partner',
  components: {
    UploadImg
  },
  data () {
    return {
      total: 0,
      list: [],
      page: 1,
      per_page: 10,
      edit: false,
      talk: [],
      movie: [],
      form: {
        thumb: '',
        images: [],
        logo: '',
        title: '',
        title_en: '',
        description: '',
        description_en: '',
        wx_name: '',
        wx_qrcode: '',
        movie: [],
        movie_title: '',
        movie_title_en: '',
        is_show_movie: 1,
        screening_programs: [],
        screening_programs_title: '',
        screening_programs_title_en: '',
        is_show_screening_program: 1,
        is_show_interview: 1,
        is_need_partner_vip: 0,
        interview_title: '',
        interview_title_en: '',
        interviews: []
      },
      screening: [],
      dialogVisible: false,
      dialogVisible2: false,
      miniAppPath: '',
      current: {},
      key: ''
    }
  },
  created () {
    this.getPartners()
    this.getMovie()
    this.getScreening()
    this.getTalk()
  },
  watch: {
    key () {
      this.page = 1
      this.getPartners()
    }
  },
  methods: {
    showAppPath (row) {
      this.miniAppPath = 'pages/partner/index?uuid=' + row.uuid
      this.dialogVisible2 = true
    },
    handleSizeChange (e) {
      this.page = 1
      this.per_page = e
      this.getPartners()
    },
    handleCurrentChange (e) {
      this.page = e
      this.getPartners()
    },
    handleClick () {
      this.edit = false
      this.dialogVisible = true
      this.form = {
        thumb: '',
        images: [],
        logo: '',
        title: '',
        title_en: '',
        description: '',
        description_en: '',
        wx_name: '',
        wx_qrcode: '',
        movie: [],
        movie_title: '',
        movie_title_en: '',
        is_show_movie: 1,
        screening_programs: [],
        screening_programs_title: '',
        screening_programs_title_en: '',
        is_show_screening_program: 1,
        is_show_interview: 1,
        is_need_partner_vip: 0,
        interview_title: '',
        interview_title_en: '',
        interviews: []
      }
    },
    hiddenchange (e, row) {
      request({
        url: '/partners/' + row.uuid,
        method: 'patch',
        data: {
          type: e ? 'hide' : 'show'
        }
      }).then(() => {}).catch(() => {
        this.getPartners()
      })
    },
    handleStatusChange (e, row) {
      request({
        url: '/partners/' + row.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: {
            is_need_partner_vip: e ? 1 : 0
          }
        }
      }).then(() => {}).catch(() => {
        this.getPartners()
      })
    },
    deleteItem (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/partners/' + row.uuid,
          method: 'delete'
        }).then(res => {
          this.$message.success('删除成功!')
          this.getPartners()
        })
      }).catch()
    },
    editItem (row) {
      this.edit = true
      this.current = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
      this.form = {
        thumb: row.thumb,
        images: row.images,
        logo: row.logo,
        title: row.title,
        title_en: row.title_en,
        wx_name: row.wx_name,
        wx_qrcode: row.wx_qrcode,
        description: row.description,
        description_en: row.description_en,
        movie: this.current.movie || [],
        movie_title: row.movie_title,
        movie_title_en: row.movie_title_en,
        is_show_movie: row.is_show_movie,
        screening_programs: this.current.screening_programs || [],
        screening_programs_title: row.screening_programs_title,
        screening_programs_title_en: row.screening_programs_title_en,
        is_show_screening_program: row.is_show_screening_program,
        is_show_interview: row.is_show_interview,
        is_need_partner_vip: row.is_need_partner_vip,
        interview_title: row.interview_title,
        interview_title_en: row.interview_title_en,
        interviews: row.interviews || []
      }
    },
    submit () {
      request({
        url: '/partners',
        method: 'post',
        data: this.form
      }).then(res => {
        this.$message.success('创建成功!')
        this.getPartners()
        this.dialogVisible = false
      })
    },
    saveChange () {
      request({
        url: '/partners/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: this.form
        }
      }).then(res => {
        this.$message.success('更新成功!')
        this.getPartners()
        this.dialogVisible = false
      })
    },
    selectThumb () {
      let list = []
      if (this.form.thumb) {
        list = [this.form.thumb]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form.thumb = res[0]
        }
      }).catch(_ => {})
    },
    selectImages () {
      let list = []
      if (this.form.images) {
        list = this.form.images
      }
      this.$refs.upload.show(list, 'other', 10).then(res => {
        if (res.length) {
          this.form.images = res
        }
      }).catch(_ => {})
    },
    selectThumb2 () {
      let list = []
      if (this.form.logo) {
        list = [this.form.logo]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form.logo = res[0]
        }
      }).catch(_ => {})
    },
    selectWxQrcode () {
      let list = []
      if (this.form.wx_qrcode) {
        list = [this.form.wx_qrcode]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form.wx_qrcode = res[0]
        }
      }).catch(_ => {})
    },
    getPartners () {
      request({
        url: '/partners',
        params: {
          page: this.page,
          per_page: this.per_page,
          key: this.key
        }
      }).then(res => {
        this.list = res.data.list
        this.totel = res.data.item_total
      })
    },
    getMovie () {
      request({
        url: '/movie'
      }).then(res => {
        this.movie = res.data.list
      })
    },
    getScreening () {
      request({
        url: '/movie/articles?type=movie_panorama'
      }).then(res => {
        this.screening = res.data.list
      })
    },
    getTalk () {
      request({
        url: '/movie/articles?type=discussion'
      }).then(res => {
        this.talk = res.data.list
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
  .thumb {
    height: 50px;
    width: auto;
  }

}
.images-c {
    display: flex;
    flex-wrap: wrap;
    .thumb {
      margin-right: 10px;
    }
  }
.pager {
  margin: 15px 0;
}
.addimg {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  font-size: 17px;
  border: 1px dashed #999999;
  cursor: pointer;
}
.thumb {
  height: 50px;
  width: auto;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/partner/index.vue